import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import authService from '../../api/authService';
import { setToken, setUser } from '../../Utility/Utility';

const TeamLoginPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);

  const buildUserInfoFromAuth = (rawUser) => {
    if (!rawUser) return null;
    const perms = {
      allowedPages: rawUser.allowedPages || [],
      readOnly: rawUser.readOnly !== undefined ? rawUser.readOnly : false,
      actionPermissions: rawUser.actionPermissions || {},
      customPermissions: rawUser.customPermissions || {},
      tableActions: rawUser.tableActions || {}
    };
    return {
      id: rawUser.id,
      name: rawUser.name,
      email: rawUser.email,
      admin: rawUser.admin,
      role: rawUser.role,
      roleTemplateId: rawUser.roleTemplateId || '',
      roleTemplateName: rawUser.roleTemplateName || '',
      companyName: rawUser.companyName || '',
      loginType: rawUser.loginType,
      permissions: perms
    };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const res = await authService.teamLogin(formData);
      if (res.success && res.token) {
        setToken(res.token);
        if (res.user) {
          const userInfo = buildUserInfoFromAuth(res.user);
          if (userInfo) setUser(userInfo);
        }
        navigate(location.state?.from || '/', { replace: true });
      }
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light p-4">
      <div className="card border-0 shadow-sm" style={{ maxWidth: '420px', width: '100%' }}>
        <div className="card-body p-4 p-md-5">
          <h3 className="fw-700 mb-2">Team Member Login</h3>
          <p className="text-muted mb-4">Login with your team account to access the permitted pages and actions.</p>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Email</label>
              <input
                className="form-control"
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                required
              />
            </div>
            <div className="mb-4">
              <label className="form-label">Password</label>
              <input
                className="form-control"
                type="password"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                required
              />
            </div>
            <button className="btn btn-primary w-100" disabled={loading}>
              {loading ? 'Logging in...' : 'Login as Team Member'}
            </button>
          </form>
          <div className="text-center mt-3">
            <span className="text-muted">Owner account? </span>
            <Link to="/login">Use owner login</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamLoginPage;
